module.exports = __webpack_public_path__ + "media/images/firsttime_header03_sp-994d5a9d6a1dc9541c7da6a4ff833ba8.png";